import {
    AnimationBaseController,
    GameApiBase, GameRandom,
    GameStorageManager
} from "../../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../../modules/@denishussar/html5-game-engine";
import { GameModel } from "../../../Models/GameModel";
import { AnimationContents } from "../../AnimationContents";
import { GameLogic } from "../../../Logic/GameLogic";

import { ButtonController, IButtonControllerOptions } from "../../Common/ButtonController";
import { SwitchController, ISwitchControllerOptions } from "../../Common/SwitchController";
import { LocalizationContents } from "../../../LocalizationContents";

export interface IPauseScreenControllerOptions {
}

export class PauseScreenController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: IPauseScreenControllerOptions,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic,
        @Inject private _arenaApi: GameApiBase) {
        super("PauseScreenController");
        console.log('PauseScreenController', this);

    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.PAUSE_SCREEN_JSON,
            libraryName: "pause",
            childControllers: {
                Back: {
                    instanceName: "bg",
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        label: LocalizationContents.pause_resume,
                        onClick: () => {
                            this._gameLogic.unpause();
                            this._gameLogic.hideModal();
                            this._gameLogic.showMainMenu();
                            if (this.$model.tapToStart === true) {
                                this._gameLogic.showTapToStart();
                            }
                        }
                    }
                },
                ResumeButton: {
                    instanceName: "button_resume",
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        label: LocalizationContents.pause_resume,
                        onClick: () => {
                            this._gameLogic.unpause();
                            this._gameLogic.hideModal();
                            this._gameLogic.showMainMenu();
                        }
                    }
                },
                SoundButton: {
                    instanceName: "button_sound_switch",
                    controller: SwitchController,
                    model: this.$model,
                    options: <ISwitchControllerOptions>{
                        onClick: () => {
                            this._gameLogic.setSoundsOn(!this.$model.isSoundsOn);
                        },
                        switchStatus: this.$model.isSoundsOn
                    }
                },
                MusicButton: {
                    instanceName: "button_music_switch",
                    controller: SwitchController,
                    model: this.$model,
                    options: <ISwitchControllerOptions>{
                        onClick: () => {
                            this._gameLogic.setMusicOn(!this.$model.isMusicOn);
                        },
                        switchStatus: this.$model.isMusicOn
                    }
                },
                MenuButton: {
                    instanceName: "button_menu",
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        label: LocalizationContents.pause_main_menu,
                        onClick: () => {
                            this._gameLogic.exitMenu();
                        }
                    }
                }
            },
            modelWatch: {

            }
        };
    }

    protected onInitialize(): void {
        //this.setTextByQuery('title_text', LocalizationContents.pause_title);
        this.$childControllers.get('SoundButton').visible = false;
        this.$childControllers.get('MusicButton').visible = false;
        this.$childControllers.get('MenuButton').visible = false;
        this.$childControllers.get('ResumeButton').visible = false;
    }

    protected onLandscape(): void {
        this.display.scale.set(.65);
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

}

